<template>
  <div />
</template>

<script type="text/babel">
export default {
  name: 'FlashNotificationInjector',
  props: {
    type: {
      type: String,
      required: false,
      default: 'success',
    },
    title: {
      type: String,
      required: false,
      default: 'Success: ',
    },
    text: {
      type: String,
      required: true,
    },
    timeout: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  async mounted() {
    await this.$nextTick()

    this.$store.commit('baseAddNotification', {
      type: this.type,
      title: this.title,
      text: this.text,
      timeout: this.timeout,
    })
  },
}
</script>
